<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    @if (error) {
      <pr-color-panel [display]="'danger'">
        <pr-panel-body clazz="pam">
          <pr-label [name]="'error'" [width]="18" [height]="18">{{
            error?.message
          }}</pr-label>
        </pr-panel-body>
      </pr-color-panel>
    }
    <div class="row">
      <div class="col-md-12">
        <div class="formControl">
          <title
            direction="left"
            [style]="{
              'font-size': '16px',
              color: '#3376F6',
              'margin-bottom': '1.5rem',
            }"
          >
            Etes vous prêt à perdre l'intégralité de votre investissement en cas
            de défaut de la société ?
          </title>
          <pr-input-radio
            formControlName="riskTotalLoss"
            direction="column"
            [isDefault]="false"
            [options]="options"
            columns="2"
            [derrors]="derrors"
          >
          </pr-input-radio>
        </div>
      </div>
    </div>
  </form-wrapper>

  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
